import { usePermissions } from "./PermissionContext";


export default function RequirePermission({
  permission,
  children,
}) {
  const {
    can,
    loadingPermissions,
  } = usePermissions();

  if (loadingPermissions) {
    return (
      <div className="company-permissions-loading-page">
        Cargando permisos...
      </div>
    );
  }

  if (!can(permission)) {
    return (
      <section className="company-access-denied">
        <h1>Acceso restringido</h1>

        <p>
          Tu usuario no tiene permiso para acceder a este
          módulo. Solicita autorización al administrador.
        </p>
      </section>
    );
  }

  return children;
}